export const SET_CONFIG = 'WIZARD.SET_CONFIG';
export const SET_MATCHED_HINTS = 'WIZARD.SET_MATCHED_HINTS';
export const ADD_VIEWED_HINT_SUCCESS = 'WIZARD.ADD_VIEWED_HINT_SUCCESS';
